/** Which share buttons the thank-you page shows, decided from what the browser can do (2026-10-23). */
export interface ShareCapabilities {
  /** The browser has `navigator.share`. */
  canShare: boolean;
  /** The browser can hand an image file to the system share sheet (`navigator.canShare({ files })`). */
  canShareFiles: boolean;
  /** A touch device: phones and tablets, where the system sheet reaches Instagram and TikTok. */
  isTouchDevice: boolean;
  /** The offer image is ready as a file. */
  hasImageFile: boolean;
  /** The offer image is still being generated or downloaded. */
  isPreparingImage: boolean;
}

export type ImageAppsMode =
  /** Phones and tablets: the system sheet with the image, which reaches the apps. */
  | 'sheet'
  /** Desktops: save the image, copy the link and open the app's upload page in a new tab. */
  | 'download';

export interface ShareOptions {
  facebook: boolean;
  x: boolean;
  /** Instagram and TikTok have no share link, so they get the image one of two ways. */
  imageApps: boolean;
  imageAppsMode: ImageAppsMode;
  /** The image apps are shown but wait for the image. */
  imageAppsPending: boolean;
  /** The generic "More ways to share" system sheet. */
  moreWays: boolean;
  copyLink: boolean;
  /** Save the offer image to the device (desktop: a download; the image apps cover phones). */
  saveImage: boolean;
  email: boolean;
}

export function shareOptions(c: ShareCapabilities): ShareOptions {
  const imageOnTheWay = c.hasImageFile || c.isPreparingImage;
  const sheet =
    c.isTouchDevice && c.canShare && (c.hasImageFile ? c.canShareFiles : true);
  const imageApps = imageOnTheWay && (sheet || !c.isTouchDevice);
  return {
    facebook: true,
    x: true,
    imageApps,
    imageAppsMode: sheet ? 'sheet' : 'download',
    imageAppsPending: imageApps && !c.hasImageFile,
    moreWays: c.canShare,
    copyLink: true,
    saveImage: !c.isTouchDevice && imageOnTheWay,
    email: true,
  };
}

/** Phones and tablets, read from the browser once per render. */
export function detectTouchDevice(
  nav: Pick<Navigator, 'maxTouchPoints' | 'userAgent'> = navigator,
): boolean {
  if (nav.maxTouchPoints > 0) return true;
  return /iPad|iPhone|iPod|Android/.test(nav.userAgent);
}
